import add from "@/assets/add.svg";
import Button from "@/common/elements/Button";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "@/components/InmateDetails/styles";
import { useEffect, useRef, useState } from "react";
import SkillsCertificationsModal from "./SkillsCertificationsModal";
import DataTable from "@/common/elements/DataTable";
import { StyledFlex } from "@/common/styles";
import { useDispatch, useSelector } from "react-redux";
import { isNonEmptyVariable } from "@/util/common_function";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";
import Popconfirm from "@/common/elements/Popconfirm";
import API_ENDPOINTS from "@/util/api";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import dayjs from "dayjs";

const SkillsTableHeader = [
  { key: "id", text: "#" },
  { key: "skillName", text: "Skill Name" },
  { key: "skillLevel", text: "Skill Level" },
  { key: "trainingName", text: "Training Name" },
  { key: "scheduledDate", text: "Scheduled Date" },
  { key: "completedDate", text: "Completed Date" },
  { key: "certificationName", text: "Certification Name" },
  { key: "certificationDate", text: "Certification Date" },
];

const SkillsCertifications = () => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const [isModalShown, setIsModalShown] = useState(false);
  const [skillList, setSkillList] = useState([]);
  const [selectSkill, setSelectSkill] = useState(null);
  const datatableRef = useRef();

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      const skill = bookings?.skills?.map((s, index) => {
        return {
          ...s,
          id: index + 1,
          uuid: uuidV4(),
        };
      });
console.log({bookings,skill})
      setSkillList(() => skill||[]);
    } else {
      setSkillList(() => []);
    }
  }, [bookings]);

  const onRowClick = (value, index) => {
    if (isNonEmptyVariable(value)) {
      const data = {
        ...value,
        scheduledDate: isNonEmptyVariable(value?.scheduledDate)
          ? dayjs(value?.scheduledDate)
          : null,
        completedDate: isNonEmptyVariable(value?.completedDate)
          ? dayjs(value?.completedDate)
          : null,
        certificationDate: isNonEmptyVariable(value?.certificationDate)
          ? dayjs(value?.certificationDate)
          : null,
      };
      setSelectSkill(() => data);
      if(index !== null && index !== undefined) {
        onEditClick();
      }
    }
  };

  const onAddClick = () => {
    setSelectSkill(() => null);
    setIsModalShown(true);
  };

  const onEditClick = () => {
    setIsModalShown(true);
  };

  const handleSubmit = (values) => {
    let skillListData = _.cloneDeep(skillList);
    if (isNonEmptyVariable(selectSkill)) {
      skillListData = skillListData?.map((m) => {
        if (m?.uuid === selectSkill?.uuid) {
          return {
            ...m,
            ...values,
          };
        }

        return m;
      });
    } else {
      skillListData?.push(values);
    }

    setSkillList(() => skillListData);
    dispatch(
      setBookings({
        skills: skillListData,
      })
    );
    handleCancel();
  };

  const handleCancel = () => {
    setSelectSkill(() => null);
    setIsModalShown(false);
    datatableRef?.current?.resetAll();
  };

  const handleDelete = () => {
    let skillListData = _.cloneDeep(skillList);
    if (isNonEmptyVariable(selectSkill)) {
      skillListData = skillListData?.filter(
        (m) => m?.uuid !== selectSkill?.uuid
      );

      if (isNonEmptyVariable(selectSkill?.skillId)) {
        const url = API_ENDPOINTS.staff.skill.delete + selectSkill?.skillId;
        dispatch(setDeleteAPis(url));
      }
    }

    setSkillList(() => skillListData);
    dispatch(
      setBookings({
        skills: skillListData,
      })
    );

    handleCancel();
  };

  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>Skills, Trainings & Certifications</h6>
          <StyledFlex gap="10px">
            <Button
              color="primary"
              type="primary"
              className="add-btn"
              onClick={onAddClick}
              disabled={!bookingsFieldsEnabled}
            >
              Add
            </Button>
            <Button
              color="primary"
              type="primary"
              onClick={onEditClick}
              disabled={selectSkill === null}
            >
              Details
            </Button>
            <Popconfirm
              title="Delete the skill"
              description="Are you sure to delete this skill record?"
              onConfirm={handleDelete}
              onCancel={() => { }}
              okText="Yes"
              cancelText="No"
            >
              <Button
                color="primary"
                type="primary"
                disabled={selectSkill === null || !bookingsFieldsEnabled}
              >
                Delete
              </Button>
            </Popconfirm>
            <Button
              color="primary"
              type="primary"
              disabled={selectSkill === null}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </StyledFlex>
        </TableHeader>
        <DataTable
          ref={datatableRef}
          rowUniqueId="uuid"
          headers={SkillsTableHeader}
          data={skillList||[]}
          onRowClick={onRowClick}
          selected={selectSkill === null}
          allowTableSorting={true}
        />
      </InmateDetailsTableContainer>
      <SkillsCertificationsModal
        show={isModalShown}
        handleCancel={handleCancel}
        formSubmit={handleSubmit}
        selectSkill={selectSkill}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      />
    </>
  );
};

export default SkillsCertifications;
